import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import Tooltip from 'flarum/common/components/Tooltip';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
import icon from 'flarum/common/helpers/icon';
import { debounce } from 'flarum/common/utils/throttleDebounce';

import { copyToClipboard } from '../helpers/copyToClipboard';

export default class ApplicationConfigListItem extends Component {
    oninit(vnode) {
        super.oninit(vnode);

        this.application = this.attrs.application;
        this.config = this.attrs.config;
    }

    className() {
        return 'ApplicationConfigListItem' + (this.is_primary() ? ' Primary' : '');
    }

    controlClassName() {
        return 'Dropdown-toggle Button Button--icon' + (this.is_primary() ? ' Button--inverted' : '');
    }

    inputClassName() {
        return 'Label' + (!this.is_primary() ? ' Label--inverted' : ' Label--icon');
    }

    view() {
        return this.config && <div className={this.className()} data-index={this.config.id()}>{this.viewItems().toArray()}</div>;
    }

    is_primary() {
        return this.config.id() == this.application.configId();
    }

    is_input_label_disabled() {
        const target = document.getElementById('label-'+this.config.id());
        return target ? target.disabled : true;
    }

    toggle_input_label() {
        const target = document.getElementById('label-'+this.config.id());
        return target ? ((target.disabled = !target.disabled) ? target.blur() : target.focus()) : null;
    }

    delete() {
        if (confirm(extractText(app.translator.trans('xtreh-phoenix.forum.applications.configs.delete_confirmation')))) {
            this.config.delete().then(() => {
                delete this.config;
                m.redraw();
            });
        }
    }

    viewItems() {
        const items = new ItemList();

        const configLabel = this.config.name() + ((this.is_input_label_disabled() && this.is_primary()) ? (' ' + String.fromCharCode(0xF005)) : '');

        items.add(
            'widget',
            <input
                id={'label-'+this.config.id()}
                className={this.inputClassName()}
                name='key'
                type='text'
                maxlength='32'
                value={configLabel}
                aria-label={configLabel}
                enterkeyhint='done'
                onfocusout={this.toggle_input_label.bind(this)}
                oncreate={(vnode) => {
                    vnode?.dom.addEventListener('keydown', (event) => { if (event.key == 'Enter') { event.preventDefault(); this.config.save({ name: vnode?.dom.value }).then(this.toggle_input_label.bind(this)); } });
                    vnode?.dom.addEventListener('pointerup', (event) => { if (event.pointerType != 'mouse' || event.button == 0) { event.preventDefault(); if (this.is_input_label_disabled()) setRouteWithForcedRefresh(app.route('application.configs.show', { application: this.application.slug(), config: this.config.id() })); } });
                }}
                disabled
            />,
            20
        );

        items.add(
            'control',
            <div className='Control'>
                { this.controlItems().toArray() }
            </div>,
            10
        );

        return items;
    }

    controlItems() {
        const items = new ItemList();

        const isPrimary = this.is_primary();

        const canEdit = this.config.canEdit();

        items.add(
            'control',
            <Tooltip text={app.translator.trans('xtreh-phoenix.forum.applications.configs.control.control')}>
                <Dropdown buttonClassName={ this.controlClassName() } icon='fas fa-bars'>
                    <Button
                        icon="fas fa-id-card"
                        onclick={() => {
                            app.alerts.show({
                                type: 'config_id',
                                controls: [
                                    <Button
                                        className="Button Button--link"
                                        onclick={() => {
                                            copyToClipboard(this.config.id());
                                            let alert = app.alerts.show({ dismissible: true, type: 'success' }, app.translator.trans('xtreh-phoenix.forum.applications.configs.copied'));
                                            debounce(2500, () => app.alerts.dismiss(alert))();
                                        }}
                                    >
                                        {app.translator.trans('xtreh-phoenix.forum.applications.configs.copy_button')}
                                    </Button>
                                ]
                            }, app.translator.trans('xtreh-phoenix.forum.applications.configs.identifier', { config_id: this.config.id() }));
                        }}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.applications.configs.control.identifier')}
                    </Button>
                    <Button
                        icon="fas fa-edit"
                        onclick={this.toggle_input_label.bind(this)}
                        disabled={!canEdit}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.applications.configs.control.rename')}
                    </Button>
                    <Button
                        icon="fas fa-clone"
                        onclick={() => {
                            app.store.createRecord('application.configs').save(
                                { name: this.config.name() + ' copy', config: this.config.id() },
                                { params: { application: this.application.id() } }
                            ).then(() => setRouteWithForcedRefresh(app.route('application.configs', { application: this.application.slug() })));
                        }}
                        disabled={!canEdit}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.applications.configs.control.clone')}
                    </Button>
                </Dropdown>
            </Tooltip>,
            30
        )

        items.add(
            'primary',
            <Tooltip text={app.translator.trans('xtreh-phoenix.forum.applications.configs.control.primary')} tooltipVisible={isPrimary||!canEdit ? false : undefined}>
                <Button className='Button Button--icon Button--yellow' icon='fas fa-star' disabled={isPrimary||!canEdit} onclick={() => this.application.save({ config_id: this.config.id() })} />
            </Tooltip>,
            20
        )

        items.add(
            'delete',
            <Tooltip text={app.translator.trans('xtreh-phoenix.forum.applications.configs.control.delete')} tooltipVisible={isPrimary||!canEdit ? false : undefined}>
                <Button className='Button Button--icon Button--red' icon='fas fa-trash' disabled={isPrimary||!canEdit} onclick={this.delete.bind(this)}/>
            </Tooltip>,
            10
        )

        return items;
    }
}
